import React, { useState } from 'react'
import './products/Products.css'
import { Link } from "react-router-dom"


function Card({item, handleClick}) {




  return (
    
         <div class="card d-flex " >
            <Link to={`productdetails/${item.id}/${item.model}`}style={{textDecoration:'none'} } >
    <div class="imgBox">
   <img
    src={item.image}
    alt="mouse corsair"
    class="mouse"
  />
      

</div>
</Link>
<div class="contentBox">
  <h3>{item.model}</h3>
  <h2 class="price">
   {item.price}
  </h2>
  <button className='btn btn-light cartbtn' onClick={() => handleClick(item)} >Add to cart</button>

</div>
</div>

  )
}

export default Card